import "./pitch.css";
import { PitchIcon, type PitchIconName } from "./PitchIcons";
import { PitchTile } from "./PitchTile";

export interface RoleTile {
  icon: PitchIconName;
  title: string;
}

export const ROLE_TILES: RoleTile[] = [
  { icon: "supervisor", title: "Supervisor" },
  { icon: "officer", title: "Senior officer" },
  { icon: "team", title: "Officer" },
  { icon: "coordinator", title: "Control room" },
];

export const ROLE_PILLS = [
  "Rest after a night",
  "One call in three days",
  "Leave",
  "Skills",
  "Standby",
  "Fair load",
];

export const ROLE_TILES_LEAD = "Many people. Many roles. Many requirements. One roster.";
export const ROLE_TILES_JOIN = "One roster";

export interface RoleTilesProps {
  lead?: string;
  roles?: RoleTile[];
  pills?: string[];
  join?: string;
}

/** `problem.html`: role tiles and requirement pills joined to one roster. */
export function RoleTiles({
  lead = ROLE_TILES_LEAD,
  roles = ROLE_TILES,
  pills = ROLE_PILLS,
  join = ROLE_TILES_JOIN,
}: RoleTilesProps) {
  return (
    <div className="pitch pitch-roles">
      <p className="pitch-big">{lead}</p>
      <div className="pitch-grid pitch-grid-4">
        {roles.map((r) => (
          <PitchTile key={r.title} title={r.title} icon={<PitchIcon name={r.icon} size={56} />} />
        ))}
      </div>
      <div className="pitch-join">
        <ul className="pitch-pills">
          {pills.map((p) => (
            <li key={p} className="pitch-pill">
              {p}
            </li>
          ))}
        </ul>
        <span className="pitch-arrow" data-dir="right" />
        <p className="pitch-one">{join}</p>
      </div>
    </div>
  );
}
